/* Returns+ in the bag drawer and on the cart page. The markup and the state (data-rp = offer | covered | none)
   come from snippets/bg-returns-offer.liquid; in the drawer every action is a plain form, on the cart page the
   add and remove actions are buttons (the page is one form). This script adds:
   - the explainer sheet (the dialog rendered after the drawer),
   - the one-press paths: Checkout adds the cover (Continue without takes it out), stamps the
     _returns_plus_cover cart attribute that staff see on the order, then goes to checkout; if a request fails
     a form submits natively instead,
   - Remove: takes the cover out of the bag if it is there, marks the cart declined (the footer then shows the
     single plain Checkout button for the rest of that cart), and redraws in place,
   - a short loading state over the offer when the drawer opens or either container redraws (LOADING_MS),
   - clearing the declined attribute when the bag renders empty (data-rp-reset), so a later bag offers it again.
   Clicks are delegated from the containers because the theme replaces their contents on every change. */
(function () {
  var containers = [document.getElementById('Cart-Drawer'), document.getElementById('Cart')].filter(Boolean);
  if (!containers.length) {
    return;
  }
  var LOADING_MS = 500;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var sheet = document.querySelector('[data-rp-dialog]');
  var timers = [];

  function request(path, body) {
    return fetch(root + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {Accept: 'application/json', 'Content-Type': 'application/json'},
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) {
        throw new Error(path + ' ' + response.status);
      }
      return response.json();
    });
  }

  function note(value) {
    return request('cart/update.js', {attributes: {_returns_plus_cover: value}});
  }

  function setBusy(action, on) {
    action.classList.toggle('is-busy', on);
    var button = action.querySelector('button');
    if (button) {
      button.disabled = on;
    }
  }

  function refresh() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  function openSheet() {
    if (!sheet) {
      return;
    }
    if (typeof sheet.showModal === 'function') {
      sheet.showModal();
    } else {
      sheet.setAttribute('open', '');
    }
  }

  function closeSheet() {
    if (!sheet) {
      return;
    }
    if (typeof sheet.close === 'function' && sheet.open) {
      sheet.close();
    } else {
      sheet.removeAttribute('open');
    }
  }

  /* Loading state: the real content stays in place underneath, so nothing jumps. */
  function showLoading(container, index) {
    var offer = container.querySelector('[data-rp]');
    if (!offer || offer.getAttribute('data-rp') === 'none') {
      return;
    }
    offer.classList.add('is-loading');
    clearTimeout(timers[index]);
    timers[index] = setTimeout(function () {
      var current = container.querySelector('[data-rp]');
      if (current) {
        current.classList.remove('is-loading');
      }
    }, LOADING_MS);
  }

  function onClick(event) {
    if (event.target.closest('[data-rp-info]')) {
      event.preventDefault();
      openSheet();
      return;
    }
    var button = event.target.closest('button');
    if (!button) {
      return;
    }
    var plus = button.closest('[data-rp-plus]');
    var without = button.closest('[data-rp-without]');
    var remove = button.closest('[data-rp-remove]');
    var action = plus || without || remove;
    if (!action || !window.fetch) {
      return;
    }
    event.preventDefault();
    if (action.classList.contains('is-busy')) {
      return;
    }
    setBusy(action, true);

    var key = action.getAttribute('data-key');
    if (remove) {
      var removal = key ? request('cart/change.js', {id: key, quantity: 0}) : Promise.resolve();
      removal.then(function () { return note('declined'); })
        .catch(function (error) { console.error('Returns+:', error); })
        .then(refresh);
      return;
    }

    var change;
    if (plus) {
      var item = {id: Number(plus.getAttribute('data-variant')), quantity: 1, properties: {_returns_plus: 'cover'}};
      change = request('cart/add.js', {items: [item]}).then(function () { return note('added'); });
    } else {
      change = request('cart/change.js', {id: key, quantity: 0}).then(function () { return note('removed'); });
    }
    change.then(function () {
      window.location.href = root + 'checkout';
    }, function (error) {
      console.error('Returns+:', error);
      setBusy(action, false);
      if (action.tagName === 'FORM') {
        action.submit();
      }
    });
  }

  /* An emptied bag clears a decline, so a bag started days later offers Returns+ again. The Liquid marks the
     empty state with data-rp-reset while the cart still carries the declined attribute. */
  function resetIfEmpty(container) {
    var empty = container.querySelector('[data-rp-reset]:not([data-rp-resetting])');
    if (!empty) {
      return;
    }
    empty.setAttribute('data-rp-resetting', '');
    note('').catch(function (error) { console.error('Returns+:', error); });
  }

  containers.forEach(function (container, index) {
    container.addEventListener('click', onClick);
    resetIfEmpty(container);
    if (window.MutationObserver) {
      new MutationObserver(function () {
        showLoading(container, index);
        resetIfEmpty(container);
      }).observe(container, {childList: true});
    }
    if (container.id === 'Cart') {
      showLoading(container, index);
    } else {
      document.addEventListener('cart-drawer:open', function () { showLoading(container, index); });
    }
  });

  if (sheet) {
    sheet.addEventListener('click', function (event) {
      if (event.target === sheet || event.target.closest('[data-rp-close]')) {
        closeSheet();
      }
    });
  }
})();
